import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthProvider } from "./AuthContext";
import { store } from "../store/store";
import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider } from "@emotion/react";
import theme from "../config/theme";
import ErrorBoundary from "../components/error/ErrorBoundary";

export interface ProviderProps {
  children: React.ReactNode;
}

const Providers: React.FC<ProviderProps> = ({ children }) => {
  return (
    <ErrorBoundary>
      <FluentProvider theme={webLightTheme}>
        <AuthProvider>
          <Provider store={store}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
          </Provider>
        </AuthProvider>
      </FluentProvider>
    </ErrorBoundary>
  );
};

export default Providers;
